import type {
    PillarPaymentRequestTypeMap,
    PillarProcessCardTokenPaymentRequest,
    PillarTerminalSaleRequest,
    ProcessCardTokenPaymentRequest,
    TerminalSaleRequest,
    TransactionDetails,
} from '../../../payment.types';

export const CardPointeSidebarPaymentEntryActionType = {
    TERMINAL_SALE: 'terminal_sale',
    TOKEN_SALE: 'token_sale',
    STORED_TOKEN_SALE: 'stored_token_sale',
    ACH_PAYMENT: 'ach_payment',
} as const;

export type CardPointeSidebarPaymentEntryActionType =
    (typeof CardPointeSidebarPaymentEntryActionType)[keyof typeof CardPointeSidebarPaymentEntryActionType];

export const CardPointeSidebarPaymentEntryOutcome = {
    BUILT: 'built',
    UNSUPPORTED_ACTION: 'unsupported_action',
} as const;

export type CardPointeSidebarPaymentEntryOutcome =
    (typeof CardPointeSidebarPaymentEntryOutcome)[keyof typeof CardPointeSidebarPaymentEntryOutcome];

export interface CardPointeTerminalSaleSidebarPaymentEntryAction {
    readonly actionType: typeof CardPointeSidebarPaymentEntryActionType.TERMINAL_SALE;
    readonly request: TerminalSaleRequest;
}

export interface CardPointeTokenSaleSidebarPaymentEntryAction {
    readonly actionType: typeof CardPointeSidebarPaymentEntryActionType.TOKEN_SALE;
    readonly request: ProcessCardTokenPaymentRequest;
}

export interface CardPointeStoredTokenSaleSidebarPaymentEntryAction {
    readonly actionType: typeof CardPointeSidebarPaymentEntryActionType.STORED_TOKEN_SALE;
    readonly request: ProcessCardTokenPaymentRequest;
}

export interface CardPointeUnsupportedSidebarPaymentEntryAction {
    readonly actionType: typeof CardPointeSidebarPaymentEntryActionType.ACH_PAYMENT;
}

export type CardPointeSupportedSidebarPaymentEntryAction =
    | CardPointeTerminalSaleSidebarPaymentEntryAction
    | CardPointeTokenSaleSidebarPaymentEntryAction
    | CardPointeStoredTokenSaleSidebarPaymentEntryAction;

export type CardPointeSidebarPaymentEntryAction =
    | CardPointeSupportedSidebarPaymentEntryAction
    | CardPointeUnsupportedSidebarPaymentEntryAction;

export interface CardPointeSidebarPaymentEntryRequestDetails {
    readonly action: CardPointeSidebarPaymentEntryAction;
}

export type CardPointeSidebarPaymentEntryRequest =
    | PillarTerminalSaleRequest
    | PillarProcessCardTokenPaymentRequest;

export type CardPointeSidebarPaymentEntryRequestType =
    | PillarPaymentRequestTypeMap['TERMINAL_SALE']
    | PillarPaymentRequestTypeMap['PROCESS_CARD_TOKEN_PAYMENT'];

export interface CardPointeSidebarPaymentEntryNormalizedResult {
    readonly actionType: CardPointeSidebarPaymentEntryActionType;
    readonly requestType: CardPointeSidebarPaymentEntryRequestType;
    readonly transactionDetails: TransactionDetails;
}

export type CardPointeSidebarPaymentEntryResponseDetails =
    | {
          readonly outcome: typeof CardPointeSidebarPaymentEntryOutcome.BUILT;
          readonly paymentRequest: CardPointeSidebarPaymentEntryRequest;
          readonly normalizedResult: CardPointeSidebarPaymentEntryNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeSidebarPaymentEntryOutcome.UNSUPPORTED_ACTION;
          readonly actionType: typeof CardPointeSidebarPaymentEntryActionType.ACH_PAYMENT;
          readonly message: string;
      };
